import React from "react";
import { Link } from "react-router-dom";
import { Lock, Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const BillingBanner = () => {
  const { billing } = useAuth();
  if (!billing || !["trial", "expired"].includes(billing.state)) return null;
  const expired = billing.state === "expired";
  return (
    <div
      data-testid="billing-banner"
      className={`border-b ${expired ? "bg-red-50 border-red-200 text-red-800" : "bg-blue-50 border-blue-100 text-blue-800"}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
        {expired ? <Lock className="h-4 w-4 shrink-0" /> : <Clock className="h-4 w-4 shrink-0" />}
        <span className="flex-1 min-w-[12rem]">
          {expired
            ? "Testphase abgelaufen – Nur-Lesen-Modus (Abo 2,50 €/Monat)."
            : `Kostenlose Testphase: noch ${billing.trial_days_left} ${billing.trial_days_left === 1 ? "Tag" : "Tage"}.`}
        </span>
        <Link to="/abo" data-testid="billing-banner-cta" className="font-semibold underline underline-offset-4 whitespace-nowrap">
          {expired ? "Jetzt freischalten" : "Abo abschließen"}
        </Link>
      </div>
    </div>
  );
};
